export const getCsrfToken = (): string => {
    const metaToken = document.head.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

    if (metaToken) {
        return metaToken
    }

    const cookieToken = document.cookie
        .split('; ')
        .find((row) => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1]

    return cookieToken ? decodeURIComponent(cookieToken) : ''
}

export const csrfPayload = (): { _token?: string } => {
    const token = getCsrfToken()

    return token ? { _token: token } : {}
}

export const csrfHeaders = (): Record<string, string> => {
    const token = getCsrfToken()

    return token ? { 'X-CSRF-TOKEN': token } : {}
}
